/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable max-statements */
/* eslint-disable complexity */
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common'
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewContainerRef,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'
@Component({
  selector: 'app-current-price',
  templateUrl: './current-price.component.html',
  styleUrls: ['./current-price.component.scss'],
  providers: [],
})
export class CurrentPriceComponent implements OnInit, OnDestroy {
  @Input() priceModel: any = {}

  profileLongName: string
  noteText: string | AEMChunk
  bidAskPricePercent: number
  public datePipe: DatePipe
  @Output() callRefreshFunc = new EventEmitter<any>()
  delayedMarket: string
  marketPrice: string
  aemContentSub: Subscription
  currencyPipe: CurrencyPipe
  decimalPipe: DecimalPipe

  constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly centralContentService: CentralContentService,
  ) {
    this.datePipe = new DatePipe('en-US')
    this.currencyPipe = new CurrencyPipe('en-US')
    this.decimalPipe = new DecimalPipe('en-US')
  }

  ngOnInit(): void {
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.delayedMarket = this.centralContentService.getContentByBody(
          'fund_definitions_delayedprice',
          content,
        )
      },
    )
  }

  public setDialogInfo(longName = '', noteText = '', notecode = '') {
    this.profileLongName = longName
    this.noteText = notecode.concat(' - ').concat(noteText)
    this.marketPrice =
      this.priceModel.marketPriceContent['@currentDayMarketPrice']
    if (this.profileLongName === 'Market price') {
      this.noteText = this.marketPrice
    }
  }

  bidAskSpread(ask: number, bid: number) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return ((ask - bid) / ask) * 100
  }

  percentAppend(value: string) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return !isNaN(Number(value)) ? `${Number(value).toFixed(2)}%` : 'N/A'
  }

  refreshFunc() {
    this.callRefreshFunc.next(1)
  }

  announcePrice() {
    const liveRegion = document.getElementById('livePriceUpdate')
    const marketPrice = parseFloat(
      this.priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.lastTradePrice,
    )
    const formattedMarketPrice = !isNaN(marketPrice)
      ? this.currencyPipe.transform(marketPrice, 'USD', 'symbol', '1.2-2')
      : 'N/A'
    const marketPriceChange = parseFloat(
      this.priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.netChange,
    )
    const formattedMarketPriceChange = !isNaN(marketPriceChange)
      ? this.currencyPipe.transform(marketPriceChange, 'USD', 'symbol', '1.2-2')
      : 'N/A'
    const marketPriceChangePercent =
      this.percentAppend(
        this.priceModel?.delayedPrice?.quotes[0]?.equity?.pricing
          ?.priceChangePercentToday,
      ) || ''
    const openPrice =
      this.priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.openPrice
    const formattedOpenPrice = !isNaN(openPrice)
      ? this.currencyPipe.transform(openPrice, 'USD', 'symbol', '1.2-2')
      : 'N/A'
    const dayHighPrice =
      this.priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.dayHighPrice
    const formattedDayHighPrice = !isNaN(dayHighPrice)
      ? this.currencyPipe.transform(dayHighPrice, 'USD', 'symbol', '1.2-2')
      : 'N/A'
    const dayLowPrice =
      this.priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.dayLowPrice
    const formattedDayLowPrice = !isNaN(dayLowPrice)
      ? this.currencyPipe.transform(dayLowPrice, 'USD', 'symbol', '1.2-2')
      : 'N/A'
    const bidPrice =
      this.priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.bidPrice
    const askPrice =
      this.priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.askPrice
    const bidASkSpread = askPrice - bidPrice
    const formattedBidASkSpread = !isNaN(bidASkSpread)
      ? this.currencyPipe.transform(bidASkSpread, 'USD', 'symbol', '1.2-2')
      : 'N/A'
    const bidPriceChange =
      this.priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.askPrice !== 0
        ? this.bidAskSpread(askPrice, bidPrice)
        : 0
    const formattedBidPriceChange = !isNaN(bidPriceChange)
      ? this.decimalPipe.transform(bidPriceChange, '1.2-2') + '%'
      : 'N/A'
    const todaysVolume =
      this.priceModel?.delayedPrice?.quotes[0]?.equity?.volume?.todaysVolume
    const formattedTodaysVolume = !isNaN(todaysVolume)
      ? this.decimalPipe.transform(todaysVolume, '')
      : 'N/A'
    const bidSize =
      this.priceModel?.delayedPrice?.quotes[0]?.equity?.volume?.bidSize
    const askSize =
      this.priceModel?.delayedPrice?.quotes[0]?.equity?.volume?.askSize
    const size = bidSize || askSize ? bidSize + ' X ' + askSize : 'N/A'
    const tick = !isNaN(marketPriceChange)
      ? marketPriceChange > 0
        ? 'UP'
        : 'DOWN'
      : 'N/A'
    const announcement = `Market Price is ${formattedMarketPrice}.
                          Market Price Change is ${formattedMarketPriceChange} (${marketPriceChangePercent}). 
                          Open price is ${formattedOpenPrice}.
                          Day high price is ${formattedDayHighPrice}.
                          Day low is ${formattedDayLowPrice}.
                          Bid/Ask spread is ${formattedBidASkSpread} (${formattedBidPriceChange}). 
                          Volume is ${formattedTodaysVolume}.
                          Size is ${size}.
                          Tick is ${tick}.
                          `
      .trim()
      .replace(/\s+/g, ' ')
    if (liveRegion) {
      liveRegion.textContent = announcement
    }
  }

  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }
}
